// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".briq-alert[data-v-6df2467a] {\n  margin-top: -16px;\n  margin-bottom: 24px;\n}\n.briq-form-element[data-v-6df2467a] {\n  margin-bottom: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
